import { render, staticRenderFns } from "./AccountBase.vue?vue&type=template&id=b62ada8a&"
import script from "./AccountBase.vue?vue&type=script&lang=ts&"
export * from "./AccountBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports